import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Box, Button, Card, CardContent, CardHeader, IconButton, TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { useHandleFormActions } from "@arelia-hooks/formikHooks";
import { EditForm } from "./UserActivitiesContainer";
import { ChangeEvent } from "react";
import { FormEditActions } from "@arelia-components/form/FormEditActions";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';

type Props = {
  formik: FormikProps<EditForm>;
  editing: boolean;
  isLoading: boolean;
  setEditing: (editing: boolean) => void;
  addActivity: () => void;
  handleRemoveActivity: (i: number) => void;
  handeChange: (index: number, property: string) => (event: ChangeEvent<HTMLInputElement>) => void
};

export function UserActivitiesPresenter({ editing, formik, handeChange, setEditing, isLoading, addActivity, handleRemoveActivity }: Props) {
  const { handleSubmit, handleReset, handleEdit } = useHandleFormActions<EditForm>(setEditing, formik);

  const handleAddActivity = () => addActivity();

  const activities = formik.values.activities;

  return <Card sx={styles.card}>
    <CardHeader
      title="User Activities"
      action={ <FormEditActions edit={editing} handleEdit={handleEdit} handleReset={handleReset} handleSubmit={handleSubmit} /> } />
    <CardContent sx={styles.content}>
      <SpinnerWrapper loading={isLoading}>
        <Box sx={styles.activities}>
          {
            activities?.map((activity, i) =>
              editing
                ? <Box sx={styles.record} key={i}>
                    <TextField
                        value={activity.name ?? ""}
                        onChange={handeChange(i, 'name')}
                        size="small"
                        label="Name"
                        fullWidth
                      />
                      {i !== activities.length &&
                        <IconButton color="error" onClick={() => handleRemoveActivity(i)}>
                          <RemoveCircleOutlineOutlinedIcon />
                        </IconButton>
                      }
                  </Box>
                : <Typography key={i} variant="body1"> {activity.name} </Typography>
            )
          }
        </Box>
        {editing && <Button variant="text" startIcon={<AddOutlinedIcon />} onClick={() => handleAddActivity()}>
          Add
        </Button>}
      </SpinnerWrapper>
    </CardContent>
  </Card>
}

const styles = {
  card: {
    gridColumn: "span 4",
    gridRow: "span 8"
  },
  content: {
    overflow: "auto"
  },
  activities: {
    paddingTop: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  record: {
    display: "flex",
    alignItems: "center",
    gap: "6px"
  }
}
